// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_a8-3";
export var contentContainer = "_a8-0";
export var editorContainer = "_a8-1";
export var quillInputForm = "_a8-2";
export var zoneDivider = "_a8-4";